import Ajax from "Utils/ajax";
export const getExtensionUserList = (data) => Ajax.post('admin/getExtensionUserList',data);
export const updateExtension = (data) => Ajax.post('admin/updateExtension',data);

